var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('binds-list-item',_vm._g(_vm._b({staticClass:"binds-menu-item",class:[_vm.itemClasses, _vm.$bindsActiveTheme],attrs:{"disabled":_vm.disabled,"tabindex":_vm.highlighted && -1}},'binds-list-item',_vm.$attrs,false),_vm.listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }